export * from './src/d3.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/node_modules/d3-ng2-service/index.js
// module id = ../../../../d3-ng2-service/index.js
// module chunks = vendor